import { render, staticRenderFns } from "./wiki-header.vue?vue&type=template&id=37c4963c&"
import script from "./wiki-header.vue?vue&type=script&lang=ts&"
export * from "./wiki-header.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports